var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0834 5.5H2.91663",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6944 7.58337L15.3111 13.3326C15.1637 15.5451 15.0899 16.6513 14.3691 17.3257C13.6482 18 12.5396 18 10.3222 18H9.67775C7.46042 18 6.35175 18 5.63091 17.3257C4.91007 16.6513 4.83632 15.5451 4.68883 13.3326L4.30554 7.58337",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91669 9.66663L8.33335 13.8333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0834 9.66663L11.6667 13.8333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41669 5.5C5.46325 5.5 5.48654 5.5 5.50764 5.49947C6.19385 5.48208 6.79921 5.04576 7.0327 4.40027C7.03988 4.38041 7.04725 4.35832 7.06197 4.31415L7.14288 4.07143C7.21194 3.86423 7.24648 3.76063 7.29228 3.67267C7.47503 3.32173 7.81314 3.07803 8.20386 3.01564C8.30179 3 8.411 3 8.62941 3H11.3706C11.589 3 11.6982 3 11.7962 3.01564C12.1869 3.07803 12.525 3.32173 12.7078 3.67267C12.7536 3.76063 12.7881 3.86423 12.8572 4.07143L12.9381 4.31415C12.9528 4.35826 12.9602 4.38042 12.9673 4.40027C13.2008 5.04576 13.8062 5.48208 14.4924 5.49947C14.5135 5.5 14.5368 5.5 14.5834 5.5",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIco);
export default __webpack_public_path__ + "static/media/trash-ico.f6dd3ffc0ac6259a52b4b2086d42969e.svg";
export { ForwardRef as ReactComponent };